import { SupabaseClient } from '@supabase/supabase-js'
import { Row, TUserSelectKey } from './supabase.interface'

export async function getUserProfile(
  db: SupabaseClient,
  userId: string
): Promise<TUserSelectKey[]> {
  const { data, error } = await db
    .from('User')
    .select(
      `
      id,
      display_name,
      avatar_url
      `
    )
    .eq('id', userId)
    .is('deleted_at', null)
    .limit(1)

  if (error) {
    console.error('Error fetching data', error)
    return []
  }

  return data
}
